import { ReactNode } from 'react';
import { CancelSubscriptionContext } from './CancelSubscription.context';
import useCancelSubscription from './CancelSubscription.hook';

export type tCancelSubscriptionProviderProps = {
  children: ReactNode;
};

export default function CancelSubscriptionProvider(
  props: tCancelSubscriptionProviderProps,
) {
  const { children } = props;
  const contextValue = useCancelSubscription();

  return (
    <CancelSubscriptionContext.Provider value={contextValue}>
      {children}
    </CancelSubscriptionContext.Provider>
  );
}
